export const thirdPartyApis = [
    {
        type: "file",
        input: "apis/third-party-apis/v1/nibss/combined-identity-validation.yaml",
        path: "/products/third-party-apis/nibss/combined-identity-validation"
    },
    {
        type: "file",
        input: "apis/third-party-apis/v1/nibss/phone-number-validation.yaml",
        path: "/products/third-party-apis/nibss/phone-number-validation"
    },
    {
        type: "file",
        input: "apis/third-party-apis/v1/nibss/virtual-nin.yaml",
        path: "/products/third-party-apis/nibss/virtual-nin"
    },
    {
        type: "file",
        input: "apis/third-party-apis/v1/nibss/tin-verification.yaml",
        path: "/products/third-party-apis/nibss/tin-verification"
    },
    {
        type: "file",
        input: "apis/third-party-apis/v1/nibss/core-banking-application.yaml",
        path: "/products/third-party-apis/nibss/core-banking-application"
    },
    {
        type: "file",
        input: "apis/third-party-apis/v1/nibss/igree-ussd.yaml",
        path: "/products/third-party-apis/nibss/igree-ussd"
    },
]
